import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Redis = () => {
  return (
    <StartInterviewLayout type="redis"/>
  )
}

export default Redis;